import "./facets";
import "./filter-drawer";
import "./filter-count";

const COLUMNS_KEY = "plp-grid-columns";
const DEFAULT_COLUMNS = "4";

class MainCollection extends HTMLElement {
  constructor() {
    super();
    this.loadMoreWrapper = this.querySelector(
      ".main-collection__load-more-wrapper",
    );

    if (!window.matchMedia("prefers-reduced-motion").matches) {
      this.observer = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
          this._loadMore();
        }
      });

      this.observer.observe(this.loadMoreWrapper);
    }

    this.addEventListener("click", (e) => {
      const loadMore = e.target.closest("[data-load-more]");
      const viewCount = e.target.closest("[data-view-count]");

      if (loadMore) {
        e.preventDefault();
        this._loadMore();
      } else if (viewCount) {
        this._updateColumnCount(viewCount.dataset.viewCount);
      }
    });

    try {
      const count = window.localStorage.getItem(COLUMNS_KEY) || DEFAULT_COLUMNS;
      if (count) {
        this._updateColumnCount(count);
      }
    } catch (error) {
      this._updateColumnCount(DEFAULT_COLUMNS);
    }
  }

  _updateColumnCount(count) {
    try {
      window.localStorage.setItem(COLUMNS_KEY, count);
    } catch (error) {
      // do nothing
    }

    this.style.setProperty("--plp-grid-columns", count);
    // Remove existing plp-columns-* classes
    this.classList.forEach((className) => {
      if (className.startsWith("plp-columns-")) {
        this.classList.remove(className);
      }
    });

    // Add new plp-columns-{count} class
    this.classList.add(`plp-columns-${count}`);

    this.querySelectorAll("[data-view-count]").forEach((el) => {
      el.classList.toggle(
        "main-collection__view-count-button--active",
        el.dataset.viewCount === count,
      );
    });

    this._removeEditorialBlocks();
    this._insertEditorialBlocks();

    window.addEventListener("resize", () => {
      clearTimeout(this.timeout);
      setTimeout(() => {
        this._removeEditorialBlocks();
        this._insertEditorialBlocks();
      }, 200);
    });
  }

  _removeEditorialBlocks() {
    const blocks = this.querySelectorAll(".editorial-block");
    blocks.forEach((block) => block.remove());
  }

  _insertEditorialBlocks() {
    const editorialData = document.getElementById("editorial-data");
    if (!editorialData) return;

    const editorials = JSON.parse(editorialData.textContent);

    // Detect product count per row
    const activeButton = this.querySelector(
      ".main-collection__view-count-button--active",
    );
    const count = activeButton
      ? parseInt(activeButton.dataset.viewCount)
      : parseInt(
          getComputedStyle(this).getPropertyValue("--plp-grid-columns"),
        ) || 4;

    const isMobile = window.innerWidth < 1024;
    const insertedIds = new Set();

    editorials
      .sort((a, b) => {
        if (isMobile) {
          return a.mobileRow - b.mobileRow;
        }

        return a.desktopRow - b.desktopRow;
      })
      .forEach((editorial) => {
        const row = isMobile ? editorial.mobileRow : editorial.desktopRow;

        if (
          !row ||
          insertedIds.has(`${editorial.id}-${isMobile ? "mobile" : "desktop"}`)
        )
          return;

        const alignment = editorial.alignment;
        const rightOffset = count === 2 ? 1 : 2;

        let slots;
        let index;
        if (isMobile) {
          index = (row - 1) * 2;
          slots = 2;
        } else {
          index = (row - 1) * count + (alignment === "right" ? rightOffset : 0);
          if (count == 4) {
            slots = 4;
          } else {
            slots = 1;
          }
        }

        const cards = this.cards.flatMap((card) => {
          const cardSlots = parseInt(card.dataset.slots || "1");

          return new Array(cardSlots).fill(card);
        });

        if (index <= cards.length) {
          const card = cards[index];

          if (card) {
            const block = document.createElement("div");
            block.className = `editorial-block editorial-block--${isMobile ? "mobile" : "desktop"} editorial-block--align-${alignment}`;
            block.innerHTML = `
            <a href="${editorial.url}">
              <img src="${isMobile ? editorial.mobile_image : editorial.desktop_image}" alt="">
            </a>
          `;
            block.dataset.slots = slots;
            card.before(block);
            insertedIds.add(
              `${editorial.id}-${isMobile ? "mobile" : "desktop"}`,
            );
          }
        }
      });
  }

  get cards() {
    return [...this.querySelectorAll("[data-product-card], .editorial-block")];
  }

  _loadMore() {
    const loadMore = this.querySelector("[data-load-more]");
    const productGrid = this.querySelector("[data-product-grid]");

    window.theme
      .fetch(loadMore.href)
      .then((response) => response.text())
      .then((response) => {
        const doc = new DOMParser().parseFromString(response, "text/html");

        const newLoadMore = doc.querySelector("[data-load-more]");
        if (!newLoadMore) {
          loadMore.style.display = "none";
          this.observer?.disconnect();
        } else {
          loadMore.href = newLoadMore.href;
          loadMore.setAttribute(
            "data-current-page",
            newLoadMore.getAttribute("data-current-page"),
          );
          loadMore.innerHTML = newLoadMore.innerHTML;
        }

        productGrid.append(...doc.querySelectorAll("[data-product-card]"));

        this._removeEditorialBlocks();
        this._insertEditorialBlocks();
      });
  }
}

if (!customElements.get("main-collection")) {
  customElements.define("main-collection", MainCollection);
}
